/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Grid, Tab } from '@mui/material';
import { DatePickers, DialogForm, IDialogActions, ISnackbarAlert, SelectField, SnackbarAlert, TextFieldInput, TextFieldReadOnly } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { ApplicationDTO, ApplicationFilterDTO, DefectDTO, DefectFilterDTO, EnvironmentDTO, FeatureDTO, FeatureFilterDTO, PeopleDTO, PeopleFilterDTO, ReleaseAppDTO, UserDTO, ValueListDTO, WorkspaceDTO, WorkspaceFilterDTO } from '../../../shared/interfaces';
import { formatDateTime } from '../../../shared/utils';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { TabPanel } from '@mui/lab';

interface IDefectMaintenanceProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const DefectMaintenance: React.FC<IDefectMaintenanceProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {

    const [assignToList, setAssignToList] = useState<PeopleDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [priorityList, setPriorityList] = useState<ValueListDTO[]>([]);
    const [severityList, setSeverityList] = useState<ValueListDTO[]>([]);
    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [workspaceList, setWorkspaceList] = useState<WorkspaceDTO[]>([]);
    const [applicationList, setApplicationList] = useState<ApplicationDTO[]>([]);
    const [featureList, setFeatureList] = useState<FeatureDTO[]>([]);
    const [environmentList, setEnvironmentList] = useState<EnvironmentDTO[]>([]);
    const [SourceReleaseAppList, setSourceReleaseAppList] = useState<ReleaseAppDTO[]>([]);
    const [resolvedtReleaseAppList, setResolvedReleaseAppList] = useState<ReleaseAppDTO[]>([]);
    const [userList, setUserList] = useState<UserDTO[]>([]);

    const [defectDTO, setDefectDTO] = useState<DefectDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);

    const [value, setValue] = React.useState('1');

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setDefectDTO({
            ...defectDTO,
            id: '',
            name: '',
            code: 'DEF',
            description: '',
            statusId: ListId.testingsphere.defect.startstatusId,
            priorityId: '',
            severityId: '',
            typeId: '',
            resolutionDateTime: undefined,
            isAutomation: false
        } as DefectDTO);
    }, [data]);

    useEffect(() => {
        if (isOpenMaintenance) {
            handleListGetAll(ListId.testingsphere.defect.statusId, setStatusList, 'valueIndex ASC');
            handleListGetAll(ListId.testingsphere.defect.priorityId, setPriorityList);
            handleListGetAll(ListId.testingsphere.defect.severityId, setSeverityList);
            handleListGetAll(ListId.testingsphere.defect.typeId, setTypeList);
            handleApplicationGetAll(setApplicationList);
            handlePeopleGetAll(setAssignToList);
            handleWorkspaceGetAllAsync();
            handleUserGetAllAsync();
            handleGetDefectByIdAsync();
        }
    }, [data, isOpenMaintenance]);

    useEffect(() => {
        handleFeatureGetAll(setFeatureList);
    }, [defectDTO?.applicationId]);

    const handleListGetAll = useCallback(async (listId: string, setList: any, orderBy = 'value ASC') => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: orderBy
        };
        GenericService.GetAllAsync1('parmsphere.valueList', valueListFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handlePeopleGetAll = useCallback(async (setList: any) => {
        const peopleFilterDTO: PeopleFilterDTO = {
            companyId: userInfo.user.companyId,
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handleWorkspaceGetAllAsync = useCallback(async () => {
        const workspaceFilterDTO: WorkspaceFilterDTO = {
            name: '',
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('testingSphere.workspace', workspaceFilterDTO, setLoading, setWorkspaceList, showMessage);
    }, []);

    const handleApplicationGetAll = useCallback(async (setList: any) => {
        const applicationFilterDTO: ApplicationFilterDTO = {
            companyId: userInfo.user.companyId,
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('appsphere.application', applicationFilterDTO, setLoading, setList, showMessage);
    }, []);

    const handleFeatureGetAll = useCallback(async (setList: any) => {
        if (defectDTO?.applicationId === undefined || defectDTO?.applicationId === '')
            return;

        const applicationFilterDTO: FeatureFilterDTO = {
            applicationId: defectDTO?.applicationId,
            orderBy: 'name ASC'
        };
        GenericService.GetAllAsync1('appsphere.feature', applicationFilterDTO, setLoading, setList, showMessage);
    }, [defectDTO]);

    const handleUserGetAllAsync = useCallback(async () => {
        const userFilterDTO = {
            defectId: userInfo.user.defectId,
        };
        GenericService.GetAllViewAsync1('authsphere.user', userFilterDTO, setActionExecuted, setLoading, setUserList, showMessage, false);

    }, []);

    const handleGetDefectByIdAsync = useCallback(async () => {
        GenericService.GetByIdAsync1('testingsphere.defect', data.id, setLoading, setDefectDTO, showMessage);
    }, [data]);

    const handleSaveClick = useCallback(async () => {
        const dto = defectDTO as DefectDTO;

        if (defectDTO?.id === '' || defectDTO?.id === undefined) {
            dto.createdById = userInfo.user.peopleId;
            GenericService.AddAsync1('testingsphere.defect', dto, setDefectDTO, setActionExecuted, setLoading, showMessage);
        }
        else {
            dto.updatedById = userInfo.user.id;
            GenericService.UpdateAsync1('testingsphere.defect', dto, setActionExecuted, setLoading, showMessage);
        }
    }, [defectDTO]);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);

        if (type != 'success')
            setIsOpenMaintenance(true);
    }
    const actions: IDialogActions[] = [
        { id: 'save', text: 'Save', icon: 'save_outlined', iconColor: 'primary', setAction: handleSaveClick, isClose: isOpenMaintenance },
        { id: 'close', text: 'Close', icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title='DEFECT DETAILS'
                icon='bug_report_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TabContext value={value} >
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                                        <Tab label="Details" value="1" />
                                        <Tab label="Description" value="2" />
                                        <Tab label="Resolution" value="3" />
                                    </TabList>
                                </Box>
                                <TabPanel value="1" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={10}>
                                            <TextFieldInput
                                                id='name'
                                                label='Name'
                                                value={defectDTO?.name}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                required={true}
                                                maxLength={200}
                                                autoFocus={true}
                                            // error={defectDTO?.name ? false : true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='code'
                                                label='Code'
                                                value={defectDTO?.code}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                readonly={true}
                                                maxLength={20}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='statusId'
                                                label='Status'
                                                placeholder='Status'
                                                value={defectDTO?.statusId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={statusList}
                                                required={true}
                                                hasNoneSelect={false}
                                                disabled={defectDTO?.id ? false: true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='priorityId'
                                                label='Priority'
                                                placeholder='Priority'
                                                value={defectDTO?.priorityId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={priorityList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='severityId'
                                                label='Severity'
                                                placeholder='Severity'
                                                value={defectDTO?.severityId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={severityList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='typeId'
                                                label='Type'
                                                placeholder='Type'
                                                value={defectDTO?.typeId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={typeList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='applicationId'
                                                label='Application'
                                                placeholder='Application'
                                                value={defectDTO?.applicationId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={applicationList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='featureId'
                                                label='Feature'
                                                placeholder='Feature'
                                                value={defectDTO?.featureId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={featureList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='environmentId'
                                                label='Environment'
                                                placeholder='Enrironment'
                                                value={defectDTO?.environmentId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={environmentList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <SelectField
                                                id='assignToId'
                                                label='Assign To'
                                                placeholder='Assign To'
                                                value={defectDTO?.assignToId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={assignToList}
                                                required={true}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='sourceReleaseAppId'
                                                label='Source Release'
                                                placeholder='Source Release'
                                                value={defectDTO?.sourceReleaseAppId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={assignToList}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='sourceCycle'
                                                label='Source Cycle'
                                                placeholder='Source Cycle'
                                                value={defectDTO?.sourceCycle}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                            // error={defectDTO?.name ? false : true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <SelectField
                                                id='resolvedReleaseAppId'
                                                label='Resolved Release'
                                                placeholder='Resolved Release'
                                                value={defectDTO?.resolvedReleaseAppId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={resolvedtReleaseAppList}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <TextFieldInput
                                                id='resolvedCycle'
                                                label='Resolved Cycle'
                                                placeholder='Resolved Cycle'
                                                value={defectDTO?.resolvedCycle}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                            // error={defectDTO?.name ? false : true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={8}>
                                            <SelectField
                                                id='workspaceId'
                                                label='WorkSpace'
                                                placeholder='WorkSpace'
                                                value={defectDTO?.workspaceId}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                valueList={workspaceList}
                                                hasNoneSelect={false}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DatePickers
                                                id='resolutionDeadlineDate'
                                                label='Deadline'
                                                value={defectDTO?.resolutionDeadlineDate ?? null}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <DatePickers
                                                id='resolutionDateTime'
                                                label='Resolution Date'
                                                value={defectDTO?.resolutionDateTime ?? null}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="2" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='description'
                                                label='Description'
                                                value={defectDTO?.description}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                required={true}
                                                multiline={true}
                                                rows={20}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value="3" sx={{ ml: -3, mr: -3, mb: -3 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                            <TextFieldInput
                                                id='resolution'
                                                label='Resolution'
                                                value={defectDTO?.resolution}
                                                setValue={setDefectDTO}
                                                obj={defectDTO}
                                                required={true}
                                                multiline={true}
                                                rows={20}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            </TabContext>
                        </Grid>
                        {defectDTO?.id ? (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <TextFieldReadOnly
                                        id={'id'}
                                        label='Id'
                                        value={defectDTO.id}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'createdById'}
                                        label='Created By'
                                        value={userList.find(x => x.id === defectDTO.createdById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'creationDateTime'}
                                        label='Creation Date'
                                        value={formatDateTime(String(defectDTO.creationDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updatedById'}
                                        label='Updated By'
                                        value={userList.find(x => x.id === defectDTO.updatedById)?.userName}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <TextFieldReadOnly
                                        id={'updateDateTime'}
                                        label='Update Date'
                                        value={formatDateTime(String(defectDTO.updateDateTime))}
                                        hasDivider={false}
                                        hasToolTip={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        ) : undefined}
                    </Grid>
                </React.Fragment>
            </DialogForm>
        </React.Fragment>
    );
};